import { render, staticRenderFns } from "./StartEvent.vue?vue&type=template&id=3f475378&"
import script from "./StartEvent.vue?vue&type=script&lang=js&"
export * from "./StartEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports